export const NAVBAR_PADDING_Y = 32;
export const POPOVER_HEIGHT = 76;
export const DIVIDERS_HEIGHT = 3;
export const USER_NAVCARD_HEIGHT = 76;
export const PROFILE_NAVCARD_HEIGHT = 84;
export const LOGOUT_HEIGHT = 50;
